// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions-container {
  padding-bottom: 4.8rem;
}
.actions-container > *:not(:last-child) {
  padding-bottom: 1.2rem;
}
.actions-container > p {
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/UserActionPopup/index.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAAJ","sourcesContent":[".actions-container {\n  padding-bottom: 4.8rem;\n\n  & > *:not(:last-child) {\n    padding-bottom: 1.2rem;\n  }\n\n  & > p {\n    white-space: nowrap;\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
